<template>
	<div class="wrapper">
		<div class="section section-blogs-2 topsearch">
			<div class="container main">
				<div class="md-layout">
					<div class="md-layout-item md-size-100 md-small-size-100 mx-auto">
						<router-link
								:to="{ name: 'windowParamsList' }"
								id="buttonback"
						>
							<md-icon>keyboard_arrow_left</md-icon>
							Назад к списку
							элементов
						</router-link>
					</div>
					<div class="md-layout-item md-size-100 md-small-size-100 mx-auto">
						<div class="name">
							<h3 class="title">
								Редактирование элемента справочника параметров окон:
							</h3>
							<div
									class="md-layout-item md-size-100 md-xsmall-size-100 fieldsep"
									v-if="winType"
							>
								<div class="md-layout-item md-size-40 md-xsmall-size-100 text-center fieldsep">
									<md-field
											:class="getValidationClass('typeName')"
									>
										<label>{{
											mapElementName['typeName']
											}}</label>
										<md-input
												type="text"
												v-if="action === 'delete'"
												v-model="form['typeName']"
										></md-input>
										<md-input
												type="text"
												v-else
												v-model="form['typeName']"
										></md-input>
										<span
												class="md-error"
												v-if="!$v.form.typeName.required"
										>Обязательно для заполнения</span>
									</md-field>
								</div>

								<div class="md-layout-item md-size-40 md-xsmall-size-100 text-center fieldsep">
									<md-field :class="getValidationClass('typeDesc')">
										<label>{{
											mapElementName['typeDesc']
											}}</label>
										<md-input
												readonly
												type="text"
												v-if="action === 'delete'"
												v-model.number="form['typeDesc']"
										></md-input>
										<md-input
												type="text"
												v-else
												v-model="form['typeDesc']"
										></md-input>
										<span
												class="md-error"
												v-if="!$v.form.typeDesc.required"
										>Обязательно для заполнения</span>
									</md-field>
								</div>

								<div class="md-layout-item md-size-40 md-xsmall-size-100 text-center fieldsep">
									<md-field>
										<label for="paramType">Тип параметра</label>
										<md-select name="paramType" v-model="form['paramType']">
											<md-option value="S">Строка</md-option>
											<md-option value="V">Параметры</md-option>
										</md-select>
									</md-field>
								</div>
							</div>
							<br/>
							<div class="md-layout-item md-gutter md-size-100 md-xsmall-size-100 fieldsep">
								<template v-if="winType">
									<md-button
											@click="validateData(saveItem)"
											class="md-button md-success md-theme-default"
											v-if="action !== 'delete'"
									>Сохранить
									</md-button
									>

									<md-button
											@click="validateData(deleteItem)"
											class="md-button md-primary md-theme-default"
											v-if="action === 'delete'"
									>Удалить
									</md-button>
								</template>
							</div>

							<md-card class="md-card-plain" v-if="winType.values && winType.paramType === 'V'">
								<h4>Привязанные свойства</h4>
								<div class="md-layout">
									<div class="md-layout-item md-size-100 md-xsmall-size-100 savebtn text-right">
										<router-link
												:to="{ name: 'windowParamsPropData', params: { id:winType.id, paramId: 'new' }}"
												class="md-primary"
												tag="md-button">
											Добавить новое свойство
										</router-link>
									</div>
								</div>
								<md-card-content>
									<md-table class="table-shopping"
											  v-model="winType.values"
											  md-sort="typeValVal"
											  md-sort-order="asc"
									>
										<md-table-row slot="md-table-row" slot-scope="{ item }">
											<md-table-cell md-label="ID">
												<router-link
														:to="{ name: 'windowParamsPropData', params: { id:winType.id, paramId: item.paramId } }">
													{{ item.paramId }}
												</router-link>
											</md-table-cell>
											<md-table-cell md-label="Название">
												<router-link
														:to="{ name: 'windowParamsPropData', params: { id:winType.id, paramId: item.paramId } }">
													{{ item.paramName }}
												</router-link>
											</md-table-cell>
											<md-table-cell md-label="Описание">
												<router-link
														:to="{ name: 'windowParamsPropData', params: { id:winType.id, paramId: item.paramId } }">
													{{ item.paramDesc }}
												</router-link>
											</md-table-cell>
											<md-table-cell md-label="Значение"
														   md-sort-by="typeValVal"
											>
												<router-link
														:to="{ name: 'windowParamsPropData', params: { id:winType.id, paramId: item.paramId } }">
													{{ item.typeValVal }}
												</router-link>
											</md-table-cell>
											<md-table-cell md-label="Описание Значения">
												<router-link
														:to="{ name: 'windowParamsPropData', params: { id:winType.id, paramId: item.paramId } }">
													{{ item.typeValDesc }}
												</router-link>
											</md-table-cell>
											<md-table-cell>
												<router-link
														:to="{ name: 'windowParamsPropData', params: { id:winType.id, paramId: item.paramId, action: 'delete'} }"
														event="" @click.native.prevent="confirmDelete({ name: 'windowParamsPropData', params: { id:winType.id, paramId: item.paramId, action: 'delete'} })"
												>
													<md-icon>delete</md-icon>
												</router-link>
											</md-table-cell>
										</md-table-row>
									</md-table>
								</md-card-content>
							</md-card>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
    import { validationMixin } from 'vuelidate'
    import { checkAuthentication, reAuthenticate } from '@/utils/auth-api'
    import { required } from 'vuelidate/lib/validators'
    import { getItem, saveItem, deleteItem } from '@/utils/dict-api'

    export default {
        mixins: [validationMixin],
        bodyClass: 'dictionary-data',
        props: ['page', 'action'],
        data () {
            return {
                winType: false,
                mapElementName: {
                    typeName: 'Название',
                    typeDesc: 'Описание',
                    paramType: 'Тип параметра',
                },
                form: {
                    action: 'save',
                    typeName: '',
                    typeDesc: '',
                    paramType: 'S',
                },
            }
        },
        validations: {
            form: {
                typeName: { required },
                typeDesc: { required },
                paramType: { required },
            },
        },
        watch: {},
        methods: {
            getValidationClass (fieldName) {
                const field = this.$v.form[fieldName]
                if (field) {
                    return {
                        'md-invalid': field.$invalid && field.$dirty,
                    }
                }
            },
            validateData (sendFn) {
                this.$v.form.$touch()
                if (!this.$v.form.$invalid) {
                    sendFn()
                }
            },
            setData: function (data) {
                let tmp = Object.assign({}, data)
                delete tmp.values
                this.form = tmp
            },
            getElementData: function () {
                if (this.$route.params.id === 'new') {
                    this.addItem()
                    return
                }
                checkAuthentication(this.$router, this.$route).then(response => {
                    getItem('windowparamtype')
                      .then(result => {
                          this.winType = result.find(
                            item => +item.id === +this.$route.params.id,
                          )
                          this.setData(this.winType)
                      })
                      .catch(error => {
                          reAuthenticate(this.$router, this.$route, error)
                      })
                })
            },
            addItem: function () {
                const item = {
                    id: 'new',
                    typeName: '',
                    typeDesc: '',
                    paramType: 'S',
                }
                this.setData(item)
                this.winType = item
            },
            saveItem: function () {
                if (this.form.id === 'new') {
                    this.form.id = null
                }
                checkAuthentication(this.$router, this.$route).then(response => {
                    saveItem('windowparamtype', JSON.stringify(this.form))
                      .then(result => {
                          this.$router.push({ name: 'windowParamsList' })
                      })
                      .catch(error => {
                          reAuthenticate(this.$router, this.$route, error)
                      })
                })
            },
            deleteItem: function () {
                checkAuthentication(this.$router, this.$route).then(response => {
                    deleteItem(
                      'windowparamtype',
                      JSON.stringify({ id: this.$route.params.id }),
                    )
                      .then(result => {
                          this.$router.push({ name: 'windowParamsList' })
                      })
                      .catch(error => {
                          reAuthenticate(this.$router, this.$route, error)
                      })
                })
            },
			confirmDelete (route) {
				if (confirm("Действительно удалить?")) {
					this.$router.push(route);
				}
			}
        },
        created () {
            if (this.$route.params.action == 'delete') {
                this.deleteItem()
            } else {
                this.getElementData()
            }
        },
    }
</script>

<style lang="scss" scoped type="text/scss">
	.dictionary-data .md-field {
		padding-top: 16px;
		margin: 4px 0 24px;
	}

	.offset-left-16 {
		margin-left: 16px;
	}
</style>
